<!-- 西瑞定制的设备界面，动态增删改特定模板设备，带遥控功能，采集由java端做 -->
<template>
	<treeBody>
		<virtualDeviceTree slot="tree" :groupCheckAble="true" :dataList="roomList" :isGroup="isGroup" :autoSelectMethod="autoSelectMethod" @checkItem="nowGroup = $event">
		</virtualDeviceTree>
		<div slot="body" style="position: relative;">
			<div class="custom-scrollbar listContainer">
				<div>
					<div class="liContainer" v-for="(item, index) in dataList" @click="nowDevice = item" title="点击查看实时信息">
						<div class="liTitle">
							<p :title="item.deviceName">{{item.deviceName}}</p>
							<img :src="$store.resourcesStore.getters.getResourcesByName('/keli/edit.png')" title="编辑" @click.stop="updateDevice(item)">
							<img :src="$store.resourcesStore.getters.getResourcesByName('/keli/delete.png')" title="删除" @click.stop="deleteDevice(item)">
						</div>
						<div style="height: 150px;" class="custom-scrollbar">
							<p class="infoContent"><span class="label">设备类型:</span><span class="markColor">{{item.tag.serverInfo.deviceSubseries}}</span></p>
							<template v-if="item.config.deviceCollectionType == 'telecomIOT'">
								<p class="infoContent"><span class="label">设备ID:</span><span class="markColor textems" :title="item.tag.serverInfo.deviceId">{{item.tag.serverInfo.deviceId}}</span></p>
							</template>
							<template v-else>
								<p class="infoContent"><span class="label">MAC:</span><span class="markColor">{{item.tag.serverInfo.mac}}</span></p>
								<p class="infoContent"><span class="label">线路地址:</span><span class="markColor">{{item.tag.serverInfo.point}}</span></p>
							</template>
							<p class="infoContent"><span class="label">数据时间:</span><span class="markColor">{{item.time}}</span></p>
							<p class="infoContent"><span class="label">创建时间:</span><span class="markColor">{{new Date(item.bean.createTime).formatByTime('-')}}</span></p>
						</div>
						<div class="onOffState" v-if="item.config.deviceCollectionType != 'telecomIOT'">
							<span class="label">开关状态</span>
							<img @click.stop="changeState(item)" :src="getOnOffImg(item)" alt="" />
						</div>
					</div>
					<div class="liContainer addButton" @click="addNewDevice">
						<img :src="$store.resourcesStore.getters.getResourcesByName('keli/add.png')" alt="" />
					</div>
				</div>
			</div>
			<div v-if="nowDevice != undefined" class="detailDiv">
				<div>
					<div class="topTitle">
						<p class="titleIamg"><img :src="$store.resourcesStore.getters.getResourcesByName('/multipleSelection/title.png')" alt="" /></p>&nbsp;&nbsp;&nbsp;&nbsp;
						<p class="diagtitle">{{nowDevice.deviceName}}</p>
						<img class="closeimg" title="关闭" @click="nowDevice = undefined" :src="$store.resourcesStore.getters.getResourcesByName('xirui/newclose.png')">
					</div>
					<div class="flexBetween">
						<div></div>

					</div>
					<div style="height: calc(100% - 90px);" class="detailBody flexBetween">
						<!-- 左边配置信息 -->
						<div class="custom-scrollbar deviceInfo">
							<div class="box_div" v-if="nowDevice.config.deviceCollectionType == 'telecomIOT'">
								<p class="addTitle">设备ID：</p>
								<input type="text" readonly :value="nowDevice.tag.serverInfo.deviceId">
							</div>
							<template v-else>
								<div class="box_div">
									<p class="addTitle">MAC地址：</p>
									<input type="text" readonly :value="nowDevice.tag.serverInfo.mac">
								</div>
								<div class="box_div">
									<p class="addTitle">线路地址：</p>
									<input type="text" readonly :value="nowDevice.tag.serverInfo.point">
								</div>
							</template>
							<div class="box_div">
								<p class="addTitle">设备类型：</p>
								<input type="text" readonly :value="nowDevice.tag.serverInfo.deviceSubseries">
							</div>
							<div class="box_div">
								<p class="addTitle">数据时间：</p>
								<input type="text" readonly :value="nowDevice.time">
							</div>
							<div class="box_div">
								<p class="addTitle">添加时间：</p>
								<input type="text" readonly :value="new Date(nowDevice.bean.createTime).formatByTime('-')">
							</div>
							<!-- 定时列表 -->
							<p v-show="nowDevice.tag.serverInfo.deviceSubseries!='Z3-JTY-GD'">定时遥控列表：</p>
							<div class="timeList" v-show="nowDevice.tag.serverInfo.deviceSubseries!='Z3-JTY-GD'">
								<p @click="addNewTimer" class="creatTimer">+ 创建新的定时遥控指令</p>
								<template v-for="item in nowTimeList">
									<div class="flexBetween" @click.stop="editTimer(item)">
										<p title="编辑" v-if="item.type == 'SINGLE'">单次&nbsp;&nbsp;<span class="tagTiem">|</span>&nbsp;&nbsp;{{item.tagObject.year}}-{{item.tagObject.month}}-{{item.tagObject.day}} {{item.tagObject.time}}
										</p>
										<p title="编辑" v-else-if="item.type == 'DAY'">每日&nbsp;&nbsp;<span class="tagTiem">|</span>&nbsp;&nbsp;{{item.tagObject.time}}</p>
										<p title="编辑" v-else-if="item.type == 'WEEK'">每周&nbsp;&nbsp;<span class="tagTiem">|</span>&nbsp;&nbsp;{{weekList[item.tagObject.week - 1]}}&nbsp;&nbsp;{{item.tagObject.time}}</p>
										<p title="编辑" v-else-if="item.type == 'MONTH'">每月&nbsp;&nbsp;<span class="tagTiem">|</span>&nbsp;&nbsp;{{item.tagObject.day}} 日&nbsp;&nbsp;
											<span class="tagTiem">|</span>&nbsp;&nbsp;{{item.tagObject.time}}</p>
										<p title="编辑" v-else-if="item.type == 'YEAR'">每年&nbsp;&nbsp;<span class="tagTiem">|</span>&nbsp;&nbsp;{{item.tagObject.month}} 月&nbsp;&nbsp;
											<span class="tagTiem">|</span> {{item.tagObject.day}} 日&nbsp;&nbsp;{{item.tagObject.time}}
										</p>
										<p>{{fenheState(item)}}</p>
										<img style="width: 15px;cursor: pointer;margin-right: 10px;padding: 10px;" title="关闭" @click.stop="deleteTimer(item)" :src="$store.resourcesStore.getters.getResourcesByName('xirui/delect.png')">
									</div>
								</template>
							</div>
						</div>
						<!-- 右边实时值 -->
						<div class="custom-scrollbar">
							<div v-for="group in nowVariableTree">
								<p class="variableGroup" >{{group.name}}({{group.unit}})</p>
								<div v-for="variable in group.next" class="flexBetween valueDiv">
									<p>{{variable.name.subByFirstChar(".")}}</p>
									<p>{{nowValueMap[variable.fromName]}}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</treeBody>
</template>

<script>
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import virtualDeviceTree from '@/components/module/tree/virtualDeviceTree.vue'
	import multipleSelection from '@/components/module/selection/multipleSelection.vue'
	import xiruiAddDeviceDialog from './xiruiAddDeviceDialog.vue'
	import setTimeRemoteDialog from '@/components/module/dialog/setTimeRemoteDialog.vue'
	export default {
		components: {
			treeBody,
			virtualDeviceTree,
			multipleSelection,
		},
		props: {},
		data() {
			return {
				//当前选中虚拟设备组
				nowGroup: undefined,
				//创建的设备的缓存信息
				createDeviceInfo: {
					tips: undefined,
					deviceName: undefined,
					archivesId: undefined,
					sort: undefined,
					deviceNo: undefined
				},
				nowDevice: undefined,
				weekList: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
			}
		},
		created() {
			debugPage = this
		},
		mounted() {},
		destroyed() {},
		computed: {
			variableStore() {
				return this.$store.variableStore
			},
			deviceStore() {
				return this.$store.deviceStore
			},
			virtualDeviceList() {
				var data = this.deviceStore.getters.getReadDeviceTree
				return isempty(data) ? [] : [data]
			},
			roomList() {
				return filterTreeRecursive(copy(this.virtualDeviceList), item => {
					return item.entityName == "AppClassType"
				})
			},
			getOnOffImg() {
				return item => {
					if(item.isOnline != undefined && item.isOnline != 1) {
						return this.$store.resourcesStore.getters.getResourcesByName('keli/state_no.png')
					}
					switch(item.isOpen) {
						case 0:
							return this.$store.resourcesStore.getters.getResourcesByName('keli/state_off.png')
						case 1:
							return this.$store.resourcesStore.getters.getResourcesByName('keli/state_on.png')
						default:
							return this.$store.resourcesStore.getters.getResourcesByName('keli/state_no.png')
					}
				}
			},
			archivesList() {
				var deviceNos = []
				this.nowDeviceList.forEach(item => {
					deviceNos.push(item.no)
				})
				var archives = this.$store.archivesStore.getters.getArchivesByDeviceNos(deviceNos)
				return archives
			},
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
			nowDeviceList() {
				//当前选中设备列表
				if(isempty(this.nowGroup)) {
					return []
				}
				//遍历虚拟设备树，查询所有被选中的组下面的设备，不包括下级的下级
				var groupList = treeToList(this.$store.deviceStore.getters.getReadDeviceTree).filter(item => item.entityName ==
					"AppClassType")
				var list = []
				//找出当前选中的部分,如果包括，下级设备就要显示,不显示下级的下级
				for(var i = 0, len = groupList.length; i < len; i++) {
					var item = groupList[i]
					if(this.nowGroup.no == item.no) {
						list.addAll(item.next.filter(it => it.entityName == "VirtualDevicePojo"))
					}
				}
				return list
			},
			nowDeviceVariableKeyList() {
				//当前界面显示所有的设备的通讯变量列表
				var list = []
				for(var i = 0, len = this.nowDeviceList.length; i < len; i++) {
					var item = this.nowDeviceList[i]
					var variableList = this.$store.variableStore.getters.getVariableTree(item.no)
					variableList.forEach(group => {
						list.addAll(group.next.map(it => it.fromName))
					})
				}
				return list
			},
			dataList() {
				//处理后需要渲染的设备列表
				var list = []
				for(var i = 0, len = this.nowDeviceList.length; i < len; i++) {
					var item = this.nowDeviceList[i]
					//获取对应的通讯设备信息
					var deviceList = this.$store.deviceStore.getters.getDeviceListByVirtualDeviceNo(item.no)
					if(deviceList[0] == undefined) {
						continue
					}
					//对应的采集配置
					var config = this.$store.deviceCollectionStore.getters.getConfigByDeviceId(deviceList[0].no, deviceList[0].parentarea)
					if(isempty(config) || !["mantunsciUDP", "telecomIOT", "mantunsciHTTP"].includes(config.deviceCollectionType)) {
						//无效的配置或者配置的不是西瑞的就过滤掉
						continue
					}
					var tag = JSON.parse(config.tag)
					var data = {
						deviceName: item.name,
						variableList: [],
						bean: item,
						deviceList,
						config,
						tag
					}
					switch(config.deviceCollectionType) {
						case "mantunsciUDP":
							data.isOpenVariable = this.variableStore.getters.getTargetApptypeVariableList(item.no, 320)[0]
							data.isOnlineVariable = this.variableStore.getters.getTargetApptypeVariableList(item.no, 321)[0]
							break
						case "mantunsciHTTP":
							data.isOpenVariable = this.variableStore.getters.getTargetApptypeVariableList(item.no, 232)[0]
							break
						case "telecomIOT":
							data.isOpenVariable = this.variableStore.getters.getTargetApptypeVariableList(item.no, 232)[0]
							break
					}
					var valueList = this.realTimeValueStore.getters.getValue([data.isOpenVariable, data.isOnlineVariable].map(it => it ==
						undefined ? "--" : it.fromName))
					var timeList = this.realTimeValueStore.getters.getTime([getValueIfNoNull(data.isOpenVariable, {}).fromName])
					data.isOpen = parseInt(getValueIfNoNull(valueList[0], -1))
					if(data.hasOwnProperty("isOnlineVariable")) {
						data.isOnline = parseInt(getValueIfNoNull(valueList[1], -1))
					}
					data.time = timeList[0] == undefined ? '--' : new Date(parseInt(timeList[0])).formatByTime('-')
					list.push(data)
				}
				return list
			},
			nowVariableTree() {
				if(this.nowDevice == undefined) {
					return []
				}
				return this.$store.variableStore.getters.getVariableTree(this.nowDevice.bean.no)
			},
			nowValueMap() {
				var map = {}
				var keys = []
				for(var i = 0, len = this.nowVariableTree.length; i < len; i++) {
					var item = this.nowVariableTree[i]
					item.next.forEach(it => {
						keys.push(it.fromName)
					})
				}
				var valueList = this.realTimeValueStore.getters.getValue(keys)
				for(var i = 0, len = keys.length; i < len; i++) {
					map[keys[i]] = getValueIfNoNull(valueList[i], '--')
				}
				return map
			},
			nowTimeList() {
				if(this.nowDevice == undefined) {
					return []
				}
				return this.$store.timeRemoteControlStore.getters.getListByDeviceNoAndParentArea(this.nowDevice.deviceList[0].no,
					this.nowDevice.deviceList[0].parentarea).map(item => {
					item.tagObject = JSON.parse(item.tag)
					return item
				})
			}

		},
		watch: {
			nowDeviceVariableKeyList(nv, ov) {
				//移除旧监听，添加新监听
				this.realTimeValueStore.commit("removeKeys", ov)
				this.realTimeValueStore.commit("addKeys", nv)
			},
			nowDeviceList(nv, ov) {}
		},
		methods: {
			fenheState(item) {
				let point = this.nowDevice.tag.serverInfo.point
				switch(item.command) {
					case 'A1;' + point:
						return '合闸'
						break;
					case 'A2;' + point:
						return '分闸'
						break;
					case 'open':
						return '合闸'
						break;
					case 'close':
						return '分闸'
						break;
				}
			},
			isGroup(item) {
				return item.hasOwnProperty('next')
			},
			autoSelectMethod(item) {
				if(this.nowGroup != undefined) {
					return item.no == this.nowGroup.no
				}
				return isempty(item.next)
			},
			getNowDeviceNos(arr1, arr2) {
				for(let i = 0; i < arr1.length; i++) {
					if(this.roomIds.includes(arr1[i].id) && !isempty(arr1[i].next)) {
						arr1[i].next.forEach(item => {
							arr2.push(item)
						})
					}
					if(!isempty(arr1[i].next)) {
						this.getNowDeviceNos(arr1[i].next, arr2)
					}
				}
			},
			// 添加新的设备，有三大类，NB的，HTTP的，UDP的
			addNewDevice() {
				this.$dialogMethod.createDialog(xiruiAddDeviceDialog).open("添加设备", result => {
					var count = 1
					var length = 4
					this.$dialogMethod.openCircleProgressDialog('准备连接...', 0)
					var inter = setInterval(() => {
						var text = ""
						switch(count) {
							case 1:
								text = "正在创建通道..."
								break
							case 2:
								text = "正在创建设备..."
								break
							case 3:
								text = "正在创建变量..."
								break
							case 4:
								text = "正在加载..."
								break
						}
						this.$dialogMethod.openCircleProgressDialog(text, parseInt(count / length * 100))
						if(count >= length) {
							this.$dialogMethod.openCircleProgressDialog('添加完成!', 100)
							clearInterval(inter)
							//刷新虚拟设备树
							this.$store.deviceStore.commit("getReadDeviceTree")
							this.$store.deviceStore.commit("getControlDeviceTree")
							setTimeout(() => {
								this.$dialogMethod.closeCircleProgressDialog()
							}, 1500)
						}
						count++
					}, 2500)
					//根据模板构筑serverInfo
					this.$api.iotApi.createDevice(result.name, result.deviceCollectionType, result.deviceGroup, result.deviceTemplate,
						result.deviceSubseries, JSON.stringify(result.serverInfo), undefined, this.nowGroup.no, respon => {}, respon => {
							clearInterval(inter)
							this.$dialogMethod.closeCircleProgressDialog()
							this.$dialogMethod.showMessage(respon)
							console.log(respon)
						})
				})
			},
			changeState(item) {
				if(item.hasOwnProperty("isOnline") && item.isOnline == -1) {
					this.$dialogMethod.showMessage("设备信息还在获取中,请稍后重试!")
					return
				}
				if(item.hasOwnProperty("isOnline") && item.isOnline != 1) {
					this.$dialogMethod.showMessage("设备离线中,请稍后重试!")
					return
				}
				this.$dialogMethod.openAgreeDialog('遥控', "是否对设备【{0}】执行【{1}】操作?".format(item.deviceName, item.isOpen == 1 ? '分闸' : "合闸"), respon => {
					var count = 1
					var length = 4
					/*this.$dialogMethod.openCircleProgressDialog('准备连接...', 0)*/
					/*var inter = setInterval(() => {
						var text = ""
						switch(count) {
							case 1:
								text = "正在搜索通道..."
								break
							case 2:
								text = "正在查找设备..."
								break
							case 3:
								text = "正在建立连接..."
								break
							case 4:
								text = "正在下发指令..."
								break
						}
						this.$dialogMethod.openCircleProgressDialog(text, parseInt(count / length * 100))
						if(count >= length) {
							this.$dialogMethod.openCircleProgressDialog('指令下发完成', 100)
							clearInterval(inter)
							setTimeout(() => {
								this.$dialogMethod.closeCircleProgressDialog()
							}, 1500)
						}
						count++
					}, 500)*/
					this.$dialogMethod.showMessage("命令已下发")
					var cmd
					switch(item.config.deviceCollectionType) {
						case 'mantunsciUDP':
							cmd = item.isOpen == 1 ? "A2;" + item.tag.serverInfo.point : "A1;" + item.tag.serverInfo.point
							break
						case 'mantunsciHTTP':
							cmd = item.isOpen == 1 ? "close" : "open"
							break
					}
					this.$api.webSocketApi.writeVariableValue(item.isOpenVariable.fromName, cmd, 15000,
						respon => {},
						failure => {
							if(!isempty(failure)) {
								this.$dialogMethod.showMessage(failure)
							}
							clearInterval(inter)
							this.$dialogMethod.closeCircleProgressDialog()
						})
				})
			},
			updateDevice(item) {
				this.$dialogMethod.createDialog(xiruiAddDeviceDialog).update("编辑设备", item, result => {
					this.$api.iotApi.updateDevice(result.no, result.name, result.serverInfo, respon => {
						this.$store.deviceCollectionStore.commit('getConfigByDeviceId', item.config.id)
						this.$store.deviceStore.commit("getReadDeviceTree")
						this.$store.deviceStore.commit("getControlDeviceTree")
						this.$dialogMethod.showMessage("更新成功!")
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
			deleteDevice(item) {
				this.$dialogMethod.openAgreeDialog("删除设备", "确定要删除设备【{0}】吗？删除之后不可撤销，请谨慎操作！".format(item.deviceName), respon => {
					this.$api.iotApi.deleteDevice(item.bean.no, respon => {
						this.$dialogMethod.showMessage("删除成功!")
						this.$store.deviceStore.commit("getReadDeviceTree")
						this.$store.deviceStore.commit("getControlDeviceTree")
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
			addNewTimer() {
			//debugger;
				this.$dialogMethod.createDialog(setTimeRemoteDialog).open("创建定时遥控", undefined, result => {
					let command = ''
					if(this.nowDevice.config.deviceCollectionType == "mantunsciHTTP") {
						if(result.command == 'A1') {
							command = 'open'
						} else {
							command = 'close'
						}
					} else {
						command = result.command+ ";" + this.nowDevice.tag.serverInfo.point
					}
					this.$api.timeRemoteControlApi.createTimedControl(this.nowDevice.deviceList[0].no, this.nowDevice.deviceList[0].parentarea,
						result.type, result.day, result.week, result.month, result.year, result.time, command , respon => {
							this.$store.timeRemoteControlStore.commit("getListByDeviceNoAndParentArea", this.nowDevice.deviceList[0].no +
								"_" + this.nowDevice.deviceList[0].parentarea)
						}, respon => {
							this.$dialogMethod.showMessage(respon)
						})
				})
			},
			deleteTimer(item) {
				this.$api.timeRemoteControlApi.deleteTimedControl(item.pkid, respon => {
					this.$dialogMethod.showMessage("删除成功!")
					this.$store.timeRemoteControlStore.commit("getListByDeviceNoAndParentArea", item.deviceId)
				}, respon => {
					this.$dialogMethod.showMessage(respon)
				})
			},
			editTimer(item) {
				this.$dialogMethod.createDialog(setTimeRemoteDialog).open("编辑定时遥控", item, result => {
					let command = ''
					if(this.nowDevice.config.deviceCollectionType == "mantunsciHTTP") {
						if(result.command == 'A1') {
							command = 'open'
						} else {
							command = 'close'
						}
					} else {
						command = result.command+ ";" + this.nowDevice.tag.serverInfo.point
					}
					this.$api.timeRemoteControlApi.updateTimedControl(item.pkid, result.type, result.day, result.week, result.month,
						result.year, result.time,command, respon => {
							this.$store.timeRemoteControlStore.commit("getListByDeviceNoAndParentArea", this.nowDevice.deviceList[0].no +
								"_" + this.nowDevice.deviceList[0].parentarea)
						}, respon => {
							this.$dialogMethod.showMessage(respon)
						})
				})
			}
		}
	}
</script>

<style scoped>
	.listContainer {
		padding: 20px;
	}
	
	.listContainer>div {
		height: auto;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		align-content: flex-start;
	}
	
	.liContainer {
		width: calc((100% - 90px) / 4);
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0 0 5px #999999;
		margin-bottom: 20px;
		margin-right: 30px;
		cursor: pointer;
	}
	
	.liContainer:nth-child(4n) {
		margin-right: 0;
	}
	
	.addButton {
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		height: 281px;
	}
	
	.liTitle {
		background-color: #56A8FC;
		height: 50px;
		line-height: 50px;
		position: relative;
	}
	
	.liTitle>p {
		width: calc(100% - 100px);
		padding-left: 50px;
		line-height: 50px;
		text-align: center;
		color: #FFFFFF;
		font-size: .16rem;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
	
	.liTitle>img {
		position: absolute;
		height: 20px;
		max-width: 20px;
		top: 15px;
		cursor: pointer;
	}
	
	.liTitle>img:first-of-type {
		right: 30px;
	}
	
	.liTitle>img:last-of-type {
		right: 5px;
	}
	
	.infoContent {
		display: flex;
		justify-content: space-between;
	}
	
	.infoContent>span {
		line-height: 30px;
	}
	
	.label {
		width: 60px;
		flex-shrink: 0;
		color: gray;
	}
	
	.infoContent>span:last-child {
		line-height: 30px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: inline-block;
	}
	
	.markColor {
		color: #5AAAFF;
	}
	
	.onOffState {
		height: 50px;
		display: flex;
		border-top: solid 1px #E4E4E4;
		justify-content: space-between;
		align-items: center;
		padding: 0 20px;
	}
	
	.onOffState {
		cursor: pointer;
	}
	
	.deviceInfo>p,
	.deviceInfo>input {
		margin: 5px 10px;
	}
	
	.custom-scrollbar {
		padding: 15px;
	}
	
	.detailDiv {
		background: rgba(0, 0, 0, 0.2);
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 2;
		top: 0;
		left: 0;
	}
	
	.detailDiv>div {
		width: calc(100% - 80px);
		height: calc(100% - 80px);
		margin: 40px;
		background-color: white;
		border-radius: 10px;
	}
	
	.detailBody>div {
		height: calc(100% - 10px);
		width: calc(50% - 10px);
		border: gray 1px solid;
		border-radius: 10px;
		margin: 5px;
	}
	
	.variableGroup {
		font-size: 16px;
		font-weight: bold;
		text-align: center;
		border-bottom: gray 1px dashed;
		line-height: 40px;
		margin: 0 10px;
	}
	
	.tagTiem {
		color: #409eff;
	}
	
	.valueDiv {
		margin: 0 10px;
		border-bottom: gray 1px dashed;
	}
	
	.valueDiv:last-of-type {
		border: none;
	}
	
	.valueDiv>p {
		margin: 0 10px;
		line-height: 30px;
	}
	
	.timeList {
		min-height: 200px;
		border: gray 1px solid;
		border-radius: 5px;
		margin: 10px;
	}
	
	.timeList p {
		line-height: 35px;
		cursor: pointer;
	}
	
	.timeList>div {
		/* border-top: 1px gray dashed; */
		border-top: 1px gray solid;
		cursor: pointer;
		padding: 10px 15px;
	}
	
	.timeList>div>p:first-of-type {
		width: 60%;
	}
	
	.timeList>p:first-of-type {
		text-align: center;
		font-weight: bold;
	}
	
	.diagtitle {
		display: inline-block;
		margin-left: 10px;
		top: -5px;
		font-size: 20px;
		/* font-size: 20px;line-height: 40px;font-weight: bold; */
	}
	
	.topTitle {
		margin-bottom: 15px;
	}
	
	.titleIamg {
		display: inline-block;
		margin-left: 30px;
		margin-top: 30px;
	}
	
	.closeimg {
		/* margin-right: 10px; */
		width: 20px;
		cursor: pointer;
		padding: 5px;
		float: right;
		margin-top: 26px;
		margin-right: 22px;
	}
	
	.creatTimer {
		background-color: #409eff;
		line-height: 49px;
		color: white;
	}
	
	.box_div {
		margin-bottom: 25px;
	}
	
	.addTitle {
		display: inline-block;
		width: 20%;
		text-align: right;
	}
	
	.box_div input {
		width: 56%
	}
</style>